import { render, staticRenderFns } from "./VoiceCommands.vue?vue&type=template&id=ccb0843e&scoped=true&"
import script from "./VoiceCommands.vue?vue&type=script&lang=js&"
export * from "./VoiceCommands.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCommands.vue?vue&type=style&index=0&id=ccb0843e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb0843e",
  null
  
)

export default component.exports